import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';

const AdminEditUser = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('');
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem('adminToken');

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await axios.get(`/api/admin/user/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const user = response.data;
        setName(user.name);
        setEmail(user.email);
        setRole(user.role);
      } catch (error) {
        console.error('Error fetching user:', error);
      }
    };

    fetchUser();
  }, [id, token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(
        `/api/admin/user/${id}`,
        { name, email, role },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      navigate('/admin/user');
    } catch (error) {
      console.error('Error updating user:', error);
    }
  };

  return (
    <div className='container mx-auto px-4 py-8 max-w-[600px]'>
      <h1 className='text-3xl font-bold mb-6'>Edit User</h1>
      <form
        onSubmit={handleSubmit}
        className='bg-white p-6 shadow-lg rounded-lg'
      >
        <div className='mb-4'>
          <label className='block text-gray-700 text-sm font-bold mb-2'>
            Name
          </label>
          <input
            type='text'
            value={name}
            onChange={(e) => setName(e.target.value)}
            className='w-full p-3 border rounded'
            required
          />
        </div>
        <div className='mb-4'>
          <label className='block text-gray-700 text-sm font-bold mb-2'>
            Email
          </label>
          <input
            type='email'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className='w-full p-3 border rounded'
            required
          />
        </div>
        <div className='mb-4'>
          <label className='block text-gray-700 text-sm font-bold mb-2'>
            Role
          </label>
          <select
            value={role}
            onChange={(e) => setRole(e.target.value)}
            className='w-full p-3 border rounded'
          >
            <option value='owner'>Owner</option>
            <option value='admin'>Admin</option>
          </select>
        </div>
        <button
          type='submit'
          className='bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-700 transition duration-200'
        >
          Update User
        </button>
      </form>
    </div>
  );
};

export default AdminEditUser;

// import React, { useState, useEffect } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import axios from 'axios';
// import { FaSave } from 'react-icons/fa';

// const AdminEditUser = () => {
//   const [user, setUser] = useState({ name: '', email: '', role: '' });
//   const [loading, setLoading] = useState(true);
//   const { id } = useParams();
//   const token = localStorage.getItem('adminToken');
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchUser = async () => {
//       try {
//         const response = await axios.get(`/api/admin/users/${id}`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setUser(response.data);
//         setLoading(false);
//       } catch (error) {
//         console.error('Error fetching user:', error);
//         setLoading(false);
//       }
//     };

//     fetchUser();
//   }, [id, token]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setUser((prevState) => ({
//       ...prevState, [name]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       await axios.put(`/api/admin/users/${id}`, user, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       navigate('/admin/users');
//     } catch (error) {
//       console.error('Error updating user:', error);
//     }
//   };

//   return (
//     <div className="p-4">
//       <h1 className="text-2xl font-bold mb-4">Edit User</h1>
//       {loading ? (
//         <div>Loading...</div>
//       ) : (
//         <form onSubmit={handleSubmit}>
//           <div className="mb-4">
//             <label className="block text-gray-700 font-bold mb-2">Name</label>
//             <input
//               type="text"
//               name="name"
//               value={user.name}
//               onChange={handleChange}
//               className="border p-2 rounded w-full"
//             />
//           </div>
//           <div className="mb-4">
//             <label className="block text-gray-700 font-bold mb-2">Email</label>
//             <input
//               type="email"
//               name="email"
//               value={user.email}
//               onChange={handleChange}
//               className="border p-2 rounded w-full"
//             />
//           </div>
//           <div className="mb-4">
//             <label className="block text-gray-700 font-bold mb-2">Role</label>
//             <select
//               name="role"
//               value={user.role}
//               onChange={handleChange}
//               className="border p-2 rounded w-full"
//             >
//               <option value="owner">Owner</option>
//               <option value="admin">Admin</option>
//             </select>
//           </div>
//           <button
//             type="submit"
//             className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded flex items-center"
//           >
//             <FaSave className="mr-2" /> Save Changes
//           </button>
//         </form>
//       )}
//     </div>
//   );
// };

// export default AdminEditUser;
